import type { Punto } from "./movimientoSuave";

// Dónde se DIBUJA cada unidad en el mapa (va hasta un intervalo detrás del
// dato, ver movimientoSuave). Lo escribe el marcador de MapView en cada cuadro.
// El seguimiento centra aquí, y la vista de manejo lee de aquí para ir
// exactamente donde el marcador del mapa: con su propio algoritmo se
// desincronizaba (Daniel, 29-oct).
export const DRAWN_POSITIONS = new Map<string, Punto>();
